const article = {
  slug: 'rate-changes',
  title: 'Rate changes',
  section: 'Revenue',
  body: `
# Rate changes

## Change a unit type / unit price

Unit-type rates apply to NEW rentals. Existing tenants keep their rate
until you change their rental.

## Mass rate change

**Mass Rate Change** updates many active rentals at once - filter by
unit type, size, or tenure, preview the affected list, and apply.

## Scheduled increases with notice

Schedule the increase for a future effective date and the system sends
the tenant notice ahead of time, then applies the new rate on the
effective invoice. This is the standard play: small, regular, noticed
increases beat rare big ones.
`,
};

export default article;
